// extracted by mini-css-extract-plugin
module.exports = {"page":"page___1TeQM"};